import React from 'react';
import PropTypes from 'prop-types';
import ExecSummaryLink from '../Incidents/components/ExecSummaryLink';
import { trackIncidentDetailArtifactClick } from '../../../utils/modernUITracking';
import styles from './IncidentExecSummary.module.css';

/**
 * IncidentExecSummary - the "Executive Summary" row on the incident page (US2174775): an icon
 * for each Exec Summary Slide or Document link that exists, for every signed-in user.
 *
 * It owns its leading divider and renders nothing at all, divider included, while the links
 * load, when they failed to load, or when there are none, so an incident without links has no
 * heading and no stray gap.
 *
 * @param {Object} props
 * @param {string} props.problemId
 * @param {{kind: string, url: string}[]} props.links - ordered, from useIncidentArtifacts
 * @param {boolean} props.loading
 * @param {string} props.error
 * @param {Object} [props.newrelic]
 */
function IncidentExecSummary({ problemId, links, loading, error, newrelic = null }) {
  if (loading || error || !links || links.length === 0) return null;

  return (
    <>
      <div className={styles.divider} />
      <section className={styles.container} aria-labelledby="incident-exec-summary-title">
        <h2 id="incident-exec-summary-title" className={styles.title}>
          Executive Summary
        </h2>
        <div className={styles.icons}>
          {links.map(({ kind, url }) => (
            <ExecSummaryLink
              key={kind}
              url={url}
              kind={kind}
              onOpen={() => trackIncidentDetailArtifactClick(problemId, kind, newrelic)}
            />
          ))}
        </div>
      </section>
    </>
  );
}

IncidentExecSummary.propTypes = {
  problemId: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({ kind: PropTypes.string, url: PropTypes.string })),
  loading: PropTypes.bool,
  error: PropTypes.string,
  newrelic: PropTypes.object,
};

export default IncidentExecSummary;
